import SkeletonBar from "../shared/SkeletonBar";
import { PostListItemSkeleton } from "../post/PostListSkeletons";
import { DividedList } from "../shared/ContentList";
import { PageShell } from "../shared/PageHeader";

function IdeaCardSkeleton() {
    return (
        <article
            className="min-w-0 overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-sm"
            aria-hidden
        >
            <div className="border-b border-slate-100 px-4 py-4 md:px-5">
                <SkeletonBar className="h-6 w-4/5 max-w-full" />
            </div>
            <div className="space-y-4 px-4 pb-4 md:px-5 md:pb-5">
                <div className="space-y-2">
                    <SkeletonBar className="h-3 w-16" />
                    <SkeletonBar className="h-4 w-full" />
                    <SkeletonBar className="h-4 w-5/6" />
                </div>
                <div className="space-y-2">
                    <SkeletonBar className="h-3 w-24" />
                    <SkeletonBar className="h-4 w-full" />
                </div>
                <div className="flex gap-1.5">
                    <SkeletonBar className="h-6 w-16 rounded-full" />
                    <SkeletonBar className="h-6 w-20 rounded-full" />
                </div>
            </div>
        </article>
    );
}

export default function CampaignDetailsSkeletons({
    postCount = 2,
    ideaCount = 3,
    label = "Loading campaign",
}) {
    return (
        <PageShell>
            <div aria-busy="true" aria-label={label} role="status">
                <span className="sr-only">{label}</span>

            <nav className="mb-3" aria-hidden>
                <div className="flex flex-wrap items-center gap-1.5">
                    <SkeletonBar className="h-3 w-24" />
                    <SkeletonBar className="h-3 w-3 rounded-sm" />
                    <SkeletonBar className="h-3 w-32 max-w-[40vw]" />
                </div>
            </nav>

            <div className="mb-4 min-w-0 space-y-3">
                <SkeletonBar className="h-7 w-64 max-w-full" />

                <div className="flex flex-wrap gap-2">
                    <SkeletonBar className="h-4 w-20" />
                    <SkeletonBar className="h-4 w-24" />
                    <SkeletonBar className="h-4 w-28" />
                    <SkeletonBar className="h-4 w-32" />
                </div>

                <div>
                    <div className="mb-3 flex items-center gap-2">
                        <SkeletonBar className="h-8 w-8 shrink-0 rounded-md" />
                        <SkeletonBar className="h-4 w-28" />
                    </div>
                    <div className="grid min-w-0 grid-cols-1 gap-3 xl:grid-cols-3 xl:gap-4">
                        {Array.from({ length: ideaCount }, (_, index) => (
                            <IdeaCardSkeleton key={index} />
                        ))}
                    </div>
                </div>
            </div>

            <div className="min-w-0 w-full">
                <div className="mb-3 flex items-center gap-2">
                    <SkeletonBar className="h-8 w-8 shrink-0 rounded-md" />
                    <SkeletonBar className="h-4 w-24" />
                </div>
                <DividedList>
                    {Array.from({ length: postCount }, (_, index) => (
                        <PostListItemSkeleton key={index} />
                    ))}
                </DividedList>
            </div>
            </div>
        </PageShell>
    );
}
